// States
const state = {
	progressBar: {

		totalFields: 0,
		percentage: 0,
		totalErrors: 0
	}
};


const getters = {
	progressBar(state) {
		return state.progressBar;
	}
};

// Mutations
const mutations = {

	resetProgressBar(state, payload) {
		state.progressBar = {...payload};
	},
};

// Actions
const actions = {

};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}
